import DynamicLayout from '@rebuild/views/layout/DynamicLayout.vue';
import DynamicHome from '@rebuild/views/home/DynamicHome.vue';
import MenuFrame from '@rebuild/views/frame/MenuFrame.vue';
import ComponentFrame from '@rebuild/views/frame/ComponentFrame.vue';
import ComponentFrameSub from '@rebuild/views/frame/ComponentFrameSub.vue';
import DynamicComponentDemo from '@rebuild/views/frame/DynamicComponentDemo.vue';
import ClearComponentFrame from '@rebuild/views/frame/ClearComponentFrame.vue';
import PureComponentFrame from '@rebuild/views/frame/PureComponentFrame.vue';
import PageFrame from '@rebuild/views/frame/PageFrame.vue';

const isDev = process.env.NODE_ENV === 'development';

// 动态模板路径 - 统一使用 DynamicLayout 做中转识别
export const REBUILD_ROUTERS = [
	// ===================== 组件示例路由 =====================
	{
		path: '/investors/components/:directory',
		component: DynamicComponentDemo,
		beforeEnter: (to, from, next) => {
			if (isDev) {
				return next();
			}
			// 避免在生产环境访问
			return next({
				path: `investors/flow`,
				query: to.query
			});
		}
	},

	// ===================== 单页面 =====================
	{
		path: '/investors/:tmpl(flow|flowX|slide)',
		component: DynamicLayout,
		children: [
			// 动态首页
			{
				path: '',
				name: 'single_template_home_root',
				component: DynamicHome,
				meta: {
					source: 'home'
				}
			},
			{
				path: 'index',
				name: 'single_template_home',
				component: DynamicHome,
				meta: {
					source: 'home'
				}
			},

			// 菜单入口
			{
				path: 'mme/:menuId/:moduleId?',
				name: 'single_menu_frame',
				component: MenuFrame,
				meta: {
					source: 'menu'
				}
			},

			// 纯组件展示入口
			{
				path: 'qme/:moduleId?', // 历史路由兼容
				name: 'single_clear_component_frame',
				component: ClearComponentFrame,
				meta: {
					source: 'pureModule'
				}
			},
			{
				path: 'pure/:moduleId?', // 优先使用此路由
				name: 'single_pure_component_frame',
				component: PureComponentFrame,
				meta: {
					source: 'pureModule'
				}
			},

			// 组件、子组件入口
			{
				path: ':moduleId/:subPath',
				name: 'single_component_frame_sub',
				component: ComponentFrameSub,
				meta: {
					source: 'subModule'
				}
			},
			{
				path: ':moduleId',
				name: 'single_component_frame',
				component: ComponentFrame,
				meta: {
					source: 'module'
				}
			}
		]
	},

	// ===================== 多页面 =====================
	{
		path: '/investors/:tmpl(slideM|surf)/:tmplId',
		component: DynamicLayout,
		children: [
			{
				path: '',
				name: 'multi_template_home_root',
				component: DynamicHome
			},
			{
				path: 'index',
				name: 'multi_template_home',
				component: DynamicHome
			},

			// 语义化页面级入口
			{
				path: 'page/:menuId?/:moduleId?',
				name: 'multi_page_frame',
				component: PageFrame,
				meta: {
					source: 'page'
				}
			},

			// 纯组件展示入口
			{
				path: 'pure/:moduleId?',
				name: 'multi_pure_component_frame',
				component: PureComponentFrame,
				meta: {
					source: 'pureModule'
				}
			},

			// 菜单入口
			{
				path: 'mme/:menuId/:moduleId?',
				name: 'multi_menu_frame',
				component: MenuFrame,
				meta: {
					source: 'menu'
				}
			},

			// 组件、子组件入口
			{
				path: ':moduleId/:subPath',
				name: 'multi_component_frame_sub',
				component: ComponentFrameSub,
				meta: {
					source: 'subModule'
				}
			},
			{
				path: ':moduleId',
				name: 'multi_component_frame',
				component: ComponentFrame,
				meta: {
					source: 'module'
				}
			}
		]
	}
];
